import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { TrsEventsService } from 'src/app/services/trsevents.service';

@Component({
  selector: 'app-confirm-box',
  templateUrl: './confirm-box.component.html',
  styleUrls: ['./confirm-box.component.sass']
})
export class ConfirmBoxComponent implements OnInit {
  @Input() timerCount = 0;
  @Input() showApprovalPopUp = false;

  @Output() sessionOverTakeApprovalStatus: EventEmitter<any> = new EventEmitter();

  sessionTakeoverApprovalLabel: string = ""
  messageLabel: string = ""
  allowLabel: string = ""
  denyLabel: string = ""

  constructor(private trsService: TrsEventsService, private translationService: TranslocoService) {
    this.updateComponentLabels();
  }

  ngOnInit(): void {
    this.trsService.evtDataObservable.subscribe(response => {
      switch (response.eventName) {
        case "UPDATE_APP_LABELS": this.updateComponentLabels(); break;
      }
    });
  }

  updateSessionOverTakeResponse(allow: boolean) {
    this.sessionOverTakeApprovalStatus.emit(allow);
  }

  updateComponentLabels = (): void => {
    this.sessionTakeoverApprovalLabel = this.translationService.translate("Approval");
    this.messageLabel = `${this.translationService.translate("Another user logged in with Same lanid. Your session will end in")} `;
    this.allowLabel = this.translationService.translate("Allow");
    this.denyLabel = this.translationService.translate("Deny");
  }
}
